import { resolveAttributeName } from "./resolveAttributeName.js";
export function convertPropertiesDefinition(propertiesDefinition) {
    return Object.entries(propertiesDefinition).map(([propertyName, configPartial]) => {
        return {
            ...configPartial,
            propertyName,
            attributeName: resolveAttributeName(configPartial.attributeName),
        };
    });
}
